<template></template>
<script>
export default {
  mounted() {
    this.$store
      .dispatch("requests/delete", this.$route.params.id)
      .then(resp => {
        this.$router.push({ name: "requests" });
        this.$notify({
          type: "success",
          message: this.$t('request.successdelete')
        });
      })
      .catch(error => {
        this.$notify({
          type: "danger",
          message: this.$t('request.errordelete')
        });
      });
  }
};
</script>
<style>
</style>
